var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 227 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 113.5,
    r: 94,
    stroke: "#029B2D",
    strokeWidth: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.202 142.763a3.136 3.136 0 01-2.22-.916l-21.657-21.658a3.135 3.135 0 114.434-4.435l19.443 19.438 49.035-49.039a3.135 3.135 0 114.434 4.434l-51.254 51.255a3.11 3.11 0 01-2.215.921z",
    fill: "#029B2D",
    stroke: "#029B2D"
  })));
}
export default SvgSuccess;